/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { workspacesListSharings } from "../../funcs/workspacesListSharings.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .GetApiWorkspaceServiceV1WorkspacesSharingsWorkspaceIdRequest$inboundSchema,
};

export const tool$workspacesListSharings: ToolDefinition<typeof args> = {
  name: "workspaces_list-sharings",
  description: `List workspace sharings`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await workspacesListSharings(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
